import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { IInputList } from '../../models';
import { UntypedFormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-radio-buttons',
  templateUrl: './radio-buttons.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class RadioButtonsComponent implements OnInit {
  private readonly fb = inject(FormBuilder);

  @Input() list!: IInputList[];
  @Input() value: any;
  @Output() valueChange = new EventEmitter();
  radioListForm!: UntypedFormGroup;

  ngOnInit(): void {
    this.radioListForm = this.fb.group({
      radioInput: this.value,
    });
  }

  trackByFn(index: any) {
    return index;
  }

  onChange(key: any) {
    this.value = key;
    this.valueChange.next(key);
  }
}
